import { useModalsContext } from 'modules/webPush/WebPushV2/context';
import { BaseModalProps, ModalType } from 'modules/webPush/WebPushV2/types';
import { getIsModalOpen } from 'modules/webPush/WebPushV2/utils';
import { deleteWebPushRequest } from 'modules/webPush/actions';
import { WebPushPlatform } from 'modules/webPush/types';
import { useDispatch } from 'react-redux';
import { DestructiveButton } from 'ui/button';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const DELETE_WEB_PUSH_INTEGRATION_MODAL_ID = 'delete-web-push-integration-modal';

export const DeleteIntegrationModal = ({ onClose }: BaseModalProps) => {
  const dispatch = useDispatch();
  const { openedModals } = useModalsContext();

  const handleDelete = () => {
    dispatch(deleteWebPushRequest({ platform: WebPushPlatform.FCM }));
    onClose();
  };

  return (
    <Modal
      data-test={DELETE_WEB_PUSH_INTEGRATION_MODAL_ID}
      id={DELETE_WEB_PUSH_INTEGRATION_MODAL_ID}
      isModalOpen={getIsModalOpen(openedModals, ModalType.DeleteIntegrationModal)}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Delete integration</ModalHeader>
      <ModalBody>Are you sure you would like to delete?</ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={`${DELETE_WEB_PUSH_INTEGRATION_MODAL_ID}-submit-button`}
          onClick={handleDelete}
        >
          Delete
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
